import cc from 'classcat';
import Image from 'next/image';
import React, { memo } from 'react';

import css from './redemption-options.module.scss';
import Card from './Card';
import { RedemptionOption } from './types';

type Props = {
  minimal?: boolean;
  options: RedemptionOption[];
  title: string;
};

const RedemptionOptions: React.FC<Props> = ({ minimal = false, options, title }) => {
  return (
    <section className={cc([css.root, { [css.padded]: !minimal }])} id="redeem">
      <h2 className={cc([css.title, { [css.minimal]: minimal }])}>
        {minimal ? (
          title
        ) : (
          <Image
            alt={title}
            height="159"
            layout="responsive"
            objectFit="contain"
            src="/loyalty/your-rewards.png"
            width="817"
          />
        )}
      </h2>
      <ul className={cc([css.list, { [css.minimal]: minimal }])}>
        {options.map((option) => (
          <li className={css.item} key={option.id}>
            <Card option={option} minimal={minimal} />
          </li>
        ))}
      </ul>
    </section>
  );
};
export default memo(RedemptionOptions);
